import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ProfileCard from "../components/CardProfile";
import "./ClientFixSideHome.style.css";
import AdminMenu from "../components/AdminMenu";

interface AdminFixSideHomeProps {
  handleLogout: () => void;
  children: React.ReactNode;
}

const AdminFixSideHome: React.FC<AdminFixSideHomeProps> = ({
  children,
  handleLogout,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div className="layout-container">
      <Box
        sx={{
          display: { xs: "block", sm: "block" },
          width: "100%",
          textAlign: { xs: "right", sm: "right" },
          marginBottom: {
            xs: "50px",
            sm: "50px",
          },
        }}
      >
        {isMobile && (
          <IconButton
            onClick={handleLogout}
            aria-label="logout"
            size="large"
            className="logout-button"
          >
            <LogoutIcon sx={{ color: "#326AFD" }} />
          </IconButton>
        )}
      </Box>

      <div className="split-screen-home">
        <div className="left-column-home">
          <ProfileCard />
          <AdminMenu />
        </div>
        <div className="right-column-home">{children}</div>
      </div>
    </div>
  );
};

export default AdminFixSideHome;
